export default __webpack_public_path__ + "static/media/circuitoBanner.fe62ae94.jpg";